export enum PaymentType {
    TAKE_AWAY = 'TAKE_AWAY',
    STRIPE = 'STRIPE',
    DELIVERY_CASH = 'DELIVERY_CASH',
    DELIVERY_CARD = 'DELIVERY_CARD'
}
